<div class="w-100 text-center mb-3">
  <h1>Conference Application</h1>
</div>

<div class="text-center p-4" *ngIf="loading">
  <i class="material-icons rotate text-muted">loop</i>
</div>

<div class="alert alert-success" *ngIf="submittedApplication">
  <h4>Application submitted</h4>
  <p class="mb-0">
    {{submittedApplication.conferenceTitle}} is now {{submittedApplication.statusLabel}}.
    <span *ngIf="submittedApplication.isException">A reviewer will see the exception flags.</span>
  </p>
</div>

<div class="alert alert-warning" *ngIf="opportunityUnavailable">
  This conference opportunity is no longer open for applications.
  <a routerLink="/conference-eligibility">Return to Conference Eligibility</a> to choose another opportunity.
</div>

<ng-container *ngIf="view && !submittedApplication && !opportunityUnavailable">
  <div class="alert alert-warning" *ngIf="exceptionReasons.length">
    <b>This request does not currently meet every eligibility or timing guideline.</b>
    <div>You can still submit it for exception review.</div>
    <ul class="mb-0 mt-2">
      <li *ngFor="let reason of exceptionReasons">{{reason}}</li>
    </ul>
  </div>

  <div class="card">
    <div class="card-body">
      <h2>{{opportunity?.title || 'New Conference Request'}}</h2>
      <p class="text-muted" *ngIf="opportunity?.description">{{opportunity.description}}</p>

      <div class="row">
        <div class="col-12 col-md-6 mt-2">
          <b>Conference Title</b>
          <input class="form-control mt-2" [(ngModel)]="model.requestedTitle" [disabled]="!!opportunity" />
        </div>
        <div class="col-12 col-md-6 mt-2">
          <b>Location</b>
          <input class="form-control mt-2" [(ngModel)]="model.requestedLocation" [disabled]="!!opportunity" />
        </div>
        <div class="col-12 col-md-4 mt-2">
          <b>Level</b>
          <p-select styleClass="app-select mt-2 w-100" [options]="view.eligibility.levelResults"
                    optionLabel="levelLabel" optionValue="levelID" [(ngModel)]="model.levelID"
                    [disabled]="!!opportunity"></p-select>
        </div>
        <div class="col-12 col-md-4 mt-2">
          <b>Start Date</b>
          <input type="date" class="form-control mt-2" [(ngModel)]="model.requestedStartDate" [disabled]="!!opportunity" />
        </div>
        <div class="col-12 col-md-4 mt-2">
          <b>End Date</b>
          <input type="date" class="form-control mt-2" [(ngModel)]="model.requestedEndDate" [disabled]="!!opportunity" />
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="questions.length">
    <div class="card-body">
      <h2>Application Questions</h2>
      <div class="border-top pt-3 mt-3" *ngFor="let question of questions">
        <label class="d-block">
          <b>{{question.prompt}}</b>
          <span class="text-danger" *ngIf="question.isRequired"> *</span>
        </label>
        <div class="text-muted mb-2" *ngIf="question.helpText">{{question.helpText}}</div>

        <input *ngIf="question.questionTypeID === 1" type="text" class="form-control"
               [(ngModel)]="answers[getId(question)]" />
        <textarea *ngIf="question.questionTypeID === 2" class="form-control" rows="5"
                  [(ngModel)]="answers[getId(question)]"></textarea>
        <input *ngIf="question.questionTypeID === 3" type="number" class="form-control"
               [(ngModel)]="answers[getId(question)]" />
        <input *ngIf="question.questionTypeID === 4" type="date" class="form-control"
               [(ngModel)]="answers[getId(question)]" />

        <div *ngIf="question.questionTypeID === 5">
          <label class="d-block" *ngFor="let option of question.options">
            <input type="radio" [name]="'question-' + getId(question)" [value]="option"
                   [(ngModel)]="answers[getId(question)]" />
            {{option}}
          </label>
        </div>

        <div *ngIf="question.questionTypeID === 6">
          <label class="d-block" *ngFor="let option of question.options">
            <input type="checkbox" [checked]="isSelected(getId(question), option)"
                   (change)="toggleMultipleChoice(getId(question), option, $any($event.target).checked)" />
            {{option}}
          </label>
        </div>

        <input *ngIf="question.questionTypeID === 7" type="file" class="form-control-file"
               (change)="onFileSelected(question, $event)" />

        <app-conference-signature-question *ngIf="question.questionTypeID === 8"
                                           (signatureChange)="onSignatureChanged(question, $event)">
        </app-conference-signature-question>
      </div>
    </div>
  </div>

  <button class="btn btn-primary mt-3" [disabled]="saving" (click)="submit()">
    <i class="fas fa-paper-plane"></i> Submit Application
  </button>
</ng-container>
